import { AdditionalClassificationDto, ConditionDto, InputGroupDto } from '.';
import { InputFieldSettingDto } from '../../iota_applications/types/ApplicationDefinition';

export interface DraftSnapshot {
    conditions: ConditionDto[];
    inputGroups: InputGroupDto[];
    additionalClassifications: AdditionalClassificationDto[];
    fieldSettings: InputFieldSettingDto[];
}

// Snapshot equality intentionally ignores undefined properties, matching persisted JSON.
export const cloneJson = <T>(value: T): T => JSON.parse(JSON.stringify(value));

export interface TabContentByKind {
    conditions: ConditionDto[];
    'additional-classifications': AdditionalClassificationDto[];
    'input-group': InputGroupDto;
}

export type TabImportKind = keyof TabContentByKind;

export type CapturedTabImport = {
    [Kind in TabImportKind]: { kind: Kind; targetSnapshot: TabContentByKind[Kind] } & (Kind extends 'input-group'
        ? { targetId: string }
        : {});
}[TabImportKind];

export type ReadyTabImport = {
    [Kind in TabImportKind]: Extract<CapturedTabImport, { kind: Kind }> & {
        content: TabContentByKind[Kind];
    } & (Kind extends 'additional-classifications' ? { meta: string } : {});
}[TabImportKind];
